import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { StringUtils } from '../../../../utils/string.utils';
import { InputAutocomplete } from '../../models/input-autocomplete';

@Component({
  selector: 'custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss']
})
export class CustomInputComponent implements OnInit {
  @Input() id: string;
  @Input() form: UntypedFormControl;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() tabindex = 0;
  @Input() showWarn: boolean;
  @Input() warnMessage: string;
  @Input() hint: string;
  @Input() infoText: string;
  @Input() descriptionText: string;
  @Input() warnText: string;
  @Input() refreshPipe: boolean;
  @Input() required: boolean;
  @Input() autocomplete: InputAutocomplete;
  @Input() keyDownFn: (event: KeyboardEvent) => void;
  @Input() blurFn: (control: AbstractControl) => void;
  @Input() pasteFn: (event: ClipboardEvent) => void;

  matIconType: 'info' | 'description' | 'warn';
  matIconText: string;
  ariaLabel: string;

  constructor(private translateService: TranslateService) { }

  ngOnInit() {
    if (!this.id) {
      console.error('Input id wasn\'t specified', this);
    }

    if (this.form == null) {
      throw Error('FormControl passed to custom-input is null; id: ' + this.id + ', label: ' + this.label + ', placeholder: ' + this.placeholder);
    }

    if (this.infoText) {
      this.matIconType = 'info';
      this.matIconText = this.infoText;
    } else if (this.descriptionText) {
      this.matIconType = 'description';
      this.matIconText = this.descriptionText;
    } else if (this.warnText) {
      this.matIconType = 'warn';
      this.matIconText = this.warnText;
    }

    this.ariaLabel = this.getAriaLabel();
  }

  setNullInFormControlIfValueIsBlank() {
    if (StringUtils.isEmptyOrWhitespaces(this.form.value)) {
      this.form.setValue(null);
    }
  }

  private getAriaLabel(): string {
    let ariaLabel = '';
    if (this.label) {
      ariaLabel += this.translateService.instant(this.label);
    } else if (this.placeholder) {
      ariaLabel += this.translateService.instant(this.placeholder);
    }

    if (this.matIconType && this.matIconText) {
      ariaLabel += ' ' + this.translateService.instant(this.matIconText);
    }

    if (this.showWarn) {
      ariaLabel += ' ' + this.translateService.instant(this.warnMessage);
    }

    return ariaLabel;
  }
}
